import { render, staticRenderFns } from "./NavListGroup.vue?vue&type=template&id=4a48249c"
import script from "./NavListGroup.vue?vue&type=script&lang=js"
export * from "./NavListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports